import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./toast-group.css?inline";
import "./toast-group";
import "./toast";

@customElement("eko-toast-group")
class ToastGroup extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  // Method to add toasts
  addToast(message: string, options: { autoDismiss?: number; theme?: string } = {}) {
    const toast = document.createElement("eko-toast");

    if (typeof options.autoDismiss === "number")
      toast.setAttribute("auto-dismiss", options.autoDismiss.toString());
    if (options.theme) toast.setAttribute("theme", options.theme);

    toast.textContent = message;
    this.appendChild(toast);
    return toast;
  }

  render() {
    return html`
      <div class="eko-toast-group" role="log" aria-relevant="additions">
        <slot></slot>
      </div>
    `;
  }
}

export type ToastGroupElement = ToastGroup & HTMLElement;

declare global {
  interface HTMLElementTagNameMap {
    "eko-toast-group": ToastGroupElement;
  }
}

export default ToastGroup;
